import React from 'react';
import {useTranslation} from 'react-i18next';
import {STATIC_IMAGE} from '../../../../config/config';
import {useTimetableDays} from '../../hooks/useTimetableDays';
import AddItemActions from '../addItemMenu/AddItemActions';
import EmptyCard from '../../../../component/emptyCard/EmptyCard';

const emptyDayImage = `${STATIC_IMAGE}/app/timetable/pageNoLectures.png`;

interface EmptyDayProps {
    onAddLecture: () => void;
    onAddBreak?: () => void;
}

function EmptyDay({onAddLecture, onAddBreak}: EmptyDayProps) {
    const {t} = useTranslation('timetable');
    const {currentDateLabel} = useTimetableDays();

    return (
        <EmptyCard
            image={emptyDayImage}
            title={t('noLectures')}
            description={t('noLecturesDescription', {day: currentDateLabel})}
        >
            <AddItemActions onAddItem={onAddLecture} onAddBreak={onAddBreak} />
        </EmptyCard>
    );
}

export default EmptyDay;
